/**
 * Created by fengyan on 2018/7/17.
 */
import React, {Component} from 'react';
import {Icon} from 'jcloudui';
import './CustomerSeller.css';
import ApiClient from '../../apiClient/ApiClient';
export default class Customer extends Component {
  constructor(props, content) {
    super(props, content);
    this.state = {
      scrollTop: 0,
      // 反馈url
      feedbackUrl: '',
      // 购物车url
      cartUrl: '',
      // 购物车数量
      shopNum: 0,
      weixinCodeUrl: '',
      weixinDisplay: '',
      appDownCodeUrl: '',
      appDownDisplay: '',
      domain: ''
    };
  }

  componentWillMount() {
    var client = new ApiClient();
    // 获取购物车数量
    client.get('cart/mall/cart/queryCartItemNum').then(rs => {
      if (rs.code == 0) {
        this.setState({
          shopNum: rs.data
        });
      }
    });
    // 获取二维码
    client.get('/platform-service/mall/mobileconfig/queryAppDownUrlById').then(rs => {
      if (rs.code == 0) {
        this.setState({
          weixinCodeUrl: rs.data.weixinCodeUrl,
          weixinDisplay: rs.data.weixinDisplay,
          appDownCodeUrl: rs.data.appDownCodeUrl,
          appDownDisplay: rs.data.appDownDisplay,
        });
      }
    });
    // 域名
    client.get('/passport/logout')
      .then(
        (res) => {
          if (res.code == 0 && res.data) {
            res.data.map(_item => {
              if (_item.domainType == 1) {
                let feedbackUrl = `//${_item.domain}/website-view/user-feedback`;
                let cartUrl = `//${_item.domain}/website-view/cart`;
                const domain = _item.domain;
                this.setState({feedbackUrl: feedbackUrl, cartUrl: cartUrl, domain});
              }
            });
          }
        },
        (err) => {
        }
      );
  }

  componentDidMount() {
    document.addEventListener('scroll', () => this.onChange(), true);
    if (document) {
      if (location.host.split('.')[0] === 'shop') {
        this.shop = true;
      }
    }
  }

  toTop() {
    document.body.scrollTop = 0;
  }

  onChange() {
    this.setState({scrollTop: document.body.scrollTop});
  }

  handleCreateShangQiao() {
    let defaultUrl = 'http://p.qiao.baidu.com/cps/chat?siteId=11653509&userId=5784152';
    var iWidth = 580;
    var iHeight = 510;
    var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
    var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
    let sqUrl = this.props.SqCode ? this.props.SqCode : defaultUrl;
    window.open(sqUrl, "shangqiao", `height=510, width=580, toolbar =no, menubar=no, scrollbars=no, resizable=no, location=no, status=no, top=${iTop},left=${iLeft}`);
  }

  render() {
    return (
      <div className="customer-seller">
        {/*  进货车  */}
        <a className="customer-seller-item pd-tb" href={this.state.cartUrl} target="_blank">
          {this.state.shopNum != 0 ?
            <span className="badge">{this.state.shopNum >= 99 ? '99+' : this.state.shopNum}</span> : ''}
          <div className="customer-seller-item-icon">
            <Icon type="anticon anticon-new-icon83"/>
          </div>
          <div className="customer-seller-item-context">
            <span className="customer-seller-item-context-text">进货车</span>
          </div>
        </a>
        {/*  扫码优惠  */}
        <div className="customer-seller-item pd-tb">
          <div className="customer-seller-item-icon">
            <Icon type="new-phone iconSize"/>
          </div>
          <div className="customer-seller-item-context">
            <span className="customer-seller-item-context-text">扫码<br/>优惠</span>
          </div>
          <div className="customer-seller-item-nav">
            <ul>
              <li>
                <img src={this.state.weixinCodeUrl} width="80" height="80" className="mr10"/>
                <p>微信扫一扫<br/>
                  关注华南城网<br/>
                  微信商城</p>
              </li>
              <li>
                <img src={this.state.appDownCodeUrl} width="80" height="80" className="mr10"/>
                <p>扫描二维码<br/>
                  立即下载APP</p>
              </li>
            </ul>
          </div>
        </div>
        {/*  联系客服  */}
        <div className="customer-seller-item pd-tb" onClick={::this.handleCreateShangQiao}>
          <div className="customer-seller-item-icon">
            <Icon type="anticon anticon-new-icon86"/>
          </div>
          <div className="customer-seller-item-context">
            <span className="customer-seller-item-context-text">联系<br/>客服</span>
          </div>
        </div>
        {/*  反馈  */}
        <a className="customer-seller-item pd-tb" href={this.state.feedbackUrl} target="_blank">
          <div className="customer-seller-item-icon">
            <Icon type="anticon anticon-new-icon84"/>
          </div>
          <div className="customer-seller-item-context">
            <span className="customer-seller-item-context-text">反馈</span>
          </div>
        </a>
        {/*  帮助  */}
        {this.shop && (
          <a className="customer-seller-item pd-tb" href={`//${this.state.domain}/website-view/help-center/50`}
             target="_blank">
            <div className="customer-seller-item-icon">
              <Icon type="question-circle-o" className="fs-16"/>
            </div>
            <div className="customer-seller-item-context">
              <span className="customer-seller-item-context-text">帮助</span>
            </div>
            <div className="customer-seller-item-flex">
              帮你解决使用中遇到的问题
            </div>
          </a>
        )
        }

      </div>
    );
  }
}
